import styled from 'styled-components';

export default styled.div`
  padding-bottom: 10vh;
  border-top: ${({ theme }) => `2px solid ${theme.colors.lightGray}`};
`;
